const REPRESENTATIVE_LADDO_PHOTOS = {
  "saffron-mango-laddo": {
    image: "/images/products/saffron-mango-laddo.webp",
    alt: "Round golden saffron mango ladoos with saffron strands and mango slices",
  },
  "matcha-pistachio-laddo": {
    image: "/images/products/matcha-pistachio-laddo.webp",
    alt: "Round green matcha pistachio ladoos with chopped pistachios",
  },
  "chia-cranberry-laddo": {
    image: "/images/products/chia-cranberry-laddo.webp",
    alt: "Round chia cranberry ladoos with visible seeds and red cranberry pieces",
  },
  "rose-petal-almond-laddo": {
    image: "/images/products/rose-petal-almond-laddo.webp",
    alt: "Rose petal almond ladoos topped with pink petals and almond slivers",
  },
  "dark-chocolate-coconut-laddo": {
    image: "/images/products/dark-chocolate-coconut-laddo.webp",
    alt: "Dark chocolate coconut ladoos with a chocolate coating and white coconut centre",
  },
  "blueberry-vanilla-laddo": {
    image: "/images/products/blueberry-vanilla-laddo.webp",
    alt: "Blueberry vanilla ladoos with purple berry pieces, blueberries and vanilla pods",
  },
};

export const representativeLaddoPhoto = (product) => {
  const photo = REPRESENTATIVE_LADDO_PHOTOS[product.id];
  return photo?.image === product.image ? photo : null;
};

const LICENSED_PHOTOS = {
  "badam-halwa": {
    image: "/images/products/badam-halwa.webp", author: "Nithyasrm",
    source: "https://commons.wikimedia.org/wiki/File:Picture_of_Badam_halwa.JPG",
    alt: "Badam halwa, a traditional almond sweet",
  },
  "gongura-pickle": {
    image: "/images/products/regional/gongura-pickle.webp", author: "Chandu100",
    source: "https://commons.wikimedia.org/wiki/File:Gongura_Pickle.jpg",
    alt: "Traditional Gongura leaf pickle with dried red chillies and garlic",
  },
};

export const licensedProductPhoto = (product) => {
  const photo = LICENSED_PHOTOS[product.pack_group_id || product.id];
  return photo?.image === product.image ? photo : null;
};

export const showWholeProductPhoto = (product) =>
  product.image_source === "ai_generated" || !product.image || ["browntop-millet", "badam-halwa"].includes(product.id) || Boolean(representativeLaddoPhoto(product)) || Boolean(licensedProductPhoto(product));

export const productImageAlt = (product) => licensedProductPhoto(product)?.alt || (product.image_source === "ai_generated" ? `AI-generated representative image of ${product.name}` : null) || representativeLaddoPhoto(product)?.alt ||
  (product.id === "browntop-millet" ? "Unpolished browntop millet grains" : product.name);